(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dettaglio-ordine', {
            parent: 'entity',
            url: '/dettaglio-ordine?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.dettaglioOrdine.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordines.html',
                    controller: 'DettaglioOrdineController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dettaglioOrdine');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dettaglio-ordine-detail', {
            parent: 'entity',
            url: '/dettaglio-ordine/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.dettaglioOrdine.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-detail.html',
                    controller: 'DettaglioOrdineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dettaglioOrdine');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DettaglioOrdine', function($stateParams, DettaglioOrdine) {
                    return DettaglioOrdine.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dettaglio-ordine',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dettaglio-ordine-detail.edit', {
            parent: 'dettaglio-ordine-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-dialog.html',
                    controller: 'DettaglioOrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DettaglioOrdine', function(DettaglioOrdine) {
                            return DettaglioOrdine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dettaglio-ordine.new', {
            parent: 'dettaglio-ordine',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-dialog.html',
                    controller: 'DettaglioOrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantita: null,
                                descrizioneArticolo: null,
                                codiceArticolo: null,
                                importoUnitario: null,
                                percentualeIva: null,
                                descrizioneIva: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                versioneRecord: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dettaglio-ordine', null, { reload: 'dettaglio-ordine' });
                }, function() {
                    $state.go('dettaglio-ordine');
                });
            }]
        })
        .state('dettaglio-ordine.edit', {
            parent: 'dettaglio-ordine',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-dialog.html',
                    controller: 'DettaglioOrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DettaglioOrdine', function(DettaglioOrdine) {
                            return DettaglioOrdine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dettaglio-ordine', null, { reload: 'dettaglio-ordine' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dettaglio-ordine.delete', {
            parent: 'dettaglio-ordine',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-delete-dialog.html',
                    controller: 'DettaglioOrdineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DettaglioOrdine', function(DettaglioOrdine) {
                            return DettaglioOrdine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dettaglio-ordine', null, { reload: 'dettaglio-ordine' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
